<template>
    <v-layout wrap>
        <v-flex class="mb-4 d-flex align-items-center">
            <div>
                <h1 class="d-inline-block vertical-align-middle">{{ $t('requestpermission-details') }}</h1>
            </div>
        </v-flex>
        <!-- Add/Edit LookUp Requestpermission -->
        <v-form class="flex xs12 mb-3" @submit.prevent="saveRequestpermission">
            <v-card>
                <v-container grid-list-lg>
                    <v-layout wrap>

                        <v-flex md3 px-2 sm6 xs12>
                            <v-autocomplete :data-vv-as="$t('beneficiary-nature')"
                                            :error-messages="errors.collect('natureBeneficiary')"
                                            :item-text="getLabelByLang('name', 'name')"
                                            :items="beneficiaryNaturesList"
                                            :label="$t('beneficiary-nature') + ' *'"
                                            clearable
                                            item-value="code"
                                            name="natureBeneficiary"
                                            v-model="requestpermission.natureBeneficiary"
                                            v-validate="'required'"
                                            @change="ShowCorrectField($event)">
                                <template slot="selection" slot-scope="data">
                                    {{ $t(data.item.name) }}
                                </template>
                                <template slot="item" slot-scope="data">
                                    {{ $t(data.item.name) }}
                                </template>
                            </v-autocomplete>
                        </v-flex>
                        <v-flex mb-2 md3 px-2 sm6 xs12 v-if="jordanianin">
                            <v-text-field :data-vv-as="$t('beneficiary-national-number')"
                                          :error-messages="errors.collect('beneficiaryNationalNumJOR')"
                                          :label="$t('beneficiary-national-number') + ' *'"
                                          :name="'applicantNationalIDNum'"
                                          :disabled="!jordanianin"
                                          v-model="requestpermission.beneficiaryNationalNumJOR"
                                          v-validate="'required|numeric|max:10|min:10'"
                                          @change="GetCSPDNameBYNationalNum($event)"></v-text-field>
                        </v-flex>

                        <v-flex md4 sm6 xs12 v-if="!jordanianin">
                            <v-text-field :label="$t('benfDocumentType')"
                                          class="mr-2"
                                          v-model="requestpermission.benfDocumentType"
                                          :data-vv-as="$t('benfDocumentType')"
                                          :error-messages="errors.collect('benfDocumentType')"
                                          name="benfDocumentType"
                                          v-validate="'required'"></v-text-field>
                        </v-flex>

                        <v-flex md4 sm6 xs12 v-if="!jordanianin">
                            <v-text-field :label="$t('benfDocumentNum')"
                                          class="mr-2"
                                          v-model="requestpermission.benfDocumentNum"
                                          :data-vv-as="$t('benfDocumentNum')"
                                          :error-messages="errors.collect('benfDocumentNum')"
                                          name="benfDocumentNum"
                                          v-validate="'required'"></v-text-field>
                        </v-flex>

                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('ar-full-name')+ ' *'"
                                          v-model="requestpermission.beneficiaryFullName"
                                          v-validate="'required|max:100'"
                                          :data-vv-as="$t('ar-full-name')"
                                          :error-messages="errors.collect('beneficiaryFullName')"
                                          name="beneficiaryFullName"></v-text-field>
                        </v-flex>

                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('mobile') + '*'"
                                          v-model="requestpermission.mobile"
                                          v-validate="'required|numeric|max:15'"
                                          :data-vv-as="$t('mobile')"
                                          :error-messages="errors.collect('mobile')"
                                          name="mobile"></v-text-field>
                        </v-flex>

                        <v-flex md3 px-2 sm6 xs12>
                            <v-autocomplete :data-vv-as="$t('disability-type')"
                                            :error-messages="errors.collect('typeOfDisability')"
                                            :item-text="getLabelByLang('name', 'name')"
                                            :items="typeOfDisabilityList"
                                            :label="$t('disability-type') + ' *'"
                                            :name="'typeOfDisability'"
                                            clearable
                                            item-value="code"
                                            v-model="requestpermission.typeOfDisability"
                                            v-validate="'required|max:50'"></v-autocomplete>
                        </v-flex>

                        <v-flex md3 px-2 sm6 xs12>
                            <v-autocomplete :data-vv-as="$t('governorate')"
                                            :error-messages="errors.collect('governorate')"
                                            :item-text="getLabelByLang('name', 'name')"
                                            :items="governorateList"
                                            :label="$t('governorate') + ' *'"
                                            :name="'governorate'"
                                            clearable
                                            item-value="code"
                                            v-model="requestpermission.governorate"
                                            v-validate="'required|max:50'"></v-autocomplete>
                        </v-flex>

                        <v-flex md4 sm6 xs12>
                            <v-select :label="$t('permissionTime') +' * ' "
                                      v-model="requestpermission.permissionTime"
                                      :item-text="getLabelByLang('time', 'time')"
                                      :data-vv-as="$t('permissionTime')"
                                      :error-messages="errors.collect('permissionTime')"
                                      :items="permissionTimes"
                                      name="permissionTime"
                                      v-validate="'required'"></v-select>
                        </v-flex>

                        <v-flex mb-2 md3 px-2 sm6 xs12>
                            <v-text-field :data-vv-as="$t('accompanying-national-number')"
                                          :error-messages="errors.collect('accompanyingNationalNumJOR')"
                                          :label="$t('accompanying-national-number')"
                                          :name="'accompanyingNationalNumJOR'"
                                          v-model="requestpermission.accompanyingNationalNumJOR"
                                          v-validate="'numeric|max:10|min:10'"></v-text-field>
                        </v-flex>

                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('accompanying-ArFull-name')"
                                          v-model="requestpermission.accompanyingFullName"
                                          v-validate="'max:100'"
                                          :data-vv-as="$t('accompanying-ArFull-name')"
                                          :error-messages="errors.collect('accompanyingFullName')"
                                          name="accompanyingFullName"></v-text-field>
                        </v-flex>

                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('accompDocumentType')"
                                          class="mr-2"
                                          v-model="requestpermission.accompDocumentType"
                                          :data-vv-as="$t('accompDocumentType')"
                                          :error-messages="errors.collect('accompDocumentType')"
                                          name="accompDocumentType"></v-text-field>
                        </v-flex>

                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('accompDocumentNum')"
                                          class="mr-2"
                                          v-model="requestpermission.accompDocumentNum"
                                          :data-vv-as="$t('accompDocumentNum')"
                                          :error-messages="errors.collect('accompDocumentNum')"
                                          name="accompDocumentNum"></v-text-field>
                        </v-flex>

                        <v-flex md3 px-2 sm6 xs12>
                            <v-autocomplete :data-vv-as="$t('relativeRelation')"
                                            :error-messages="errors.collect('relativeRelation')"
                                            :item-text="getLabelByLang('name', 'name')"
                                            :items="relativeRelationList"
                                            :label="$t('relativeRelation') "
                                            :name="'relativeRelation'"
                                            clearable
                                            item-value="code"
                                            v-model="requestpermission.relativeRelation"
                                            v-validate="'max:50'"></v-autocomplete>
                        </v-flex>
                    </v-layout>

                    <v-layout mb-3 px-2 wrap>
                        <v-layout class="outlined-box column" pa-3 wrap>
                            <label class="outlined-text bg-white">{{ $t('attachments') }}</label>
                            <v-layout>
                                <v-flex md4 px-2 sm6 xs12>
                                    <v-autocomplete :data-vv-as="$t('attachment-type')"
                                                    :error-messages="errors.collect('attachmentType')"
                                                    :item-text="'fileName'"
                                                    :items="attachmentTypesList"
                                                    :label="$t('attachment-type')"
                                                    clearable
                                                    return-object
                                                    name="attachmentType"
                                                    v-model="fileCategory"></v-autocomplete>
                                </v-flex>
                                <v-btn @click="saveCategoryLocal()" color="green" dark>
                                    {{ $t('add-more') }}
                                </v-btn>
                            </v-layout>
                            <v-layout v-if="files.length > 0" mb-3>
                                <files-viewer :files="files" @removeFileEmitter="removeFile" />
                            </v-layout>
                            <v-layout>
                                <uploader :uploadedList.sync="uploadedList" :filesList="filesList" :dropzoneId="'requestpermissionDropzoneId'" :treeId="treeId" />
                            </v-layout>
                        </v-layout>
                    </v-layout>
                    <v-btn type="submit" color="green" dark>
                        {{ this.$store.getters.user.source === 4 && this.$route.params.from === '3' ? $t('send-request') : $t('save') }}
                    </v-btn>

                    <v-btn v-if="($route.name !== 'add-requestpermission') && !this.$route.params.taskId" :to="{ name: this.$store.getters.user.source !== 4 ? 'requestpermission' : 'system-landing-page' }"
                           color="red"
                           dark>
                        {{ $t('cancel') }}
                    </v-btn>
                </v-container>
            </v-card>
        </v-form>
        <v-layout wrap
                  v-if="
        ($route.name === 'add-requestpermission-by-task' || $route.name === 'edit-requestpermission-by-task') &&
          ($route.params.taskId || $route.params.from === '2')
      ">
            <actions-bar ref="actionsBar" />
        </v-layout>
    </v-layout>
</template>

<script>
    import RequestpermissionService from '@/services/Disabilities/PersonWithDisabilities/Requestpermission/RequestpermissionService';
    import LookUpService from '@/services/LookUpService';
    import BeneficiaryInformationManagementService from '@/services/Disabilities/PersonWithDisabilities/BeneficiaryInformationManagement/BeneficiaryInformationManagement/BeneficiaryInformationManagementService';
    const Uploader = () => import('@/views/Directorate/Shared/Uploader.vue');
    const FilesViewer = () => import('@/views/Directorate/Shared/FilesViewer.vue');
    import PageService from '@/services/Archiving/InstancePageService';
    import FileCategoryService from '@/services/FileCategoryService';
    const ActionsBar = () => import('@/views/ActionsBar.vue');
    import { ConfirmationEvent } from '@/components/Confirmation/ConfirmationEventBus';

    export default {
        name: 'requestpermission-details',
        data() {
            return {
                selected: [],
                // Filters
                requestpermission: {
                    id: 0,
                    beneficiaryNationalNumJOR: '',
                    beneficiaryFullName: '',
                    natureBeneficiary: '',
                    benfDocumentType: '',
                    benfDocumentNum: '',
                    typeOfDisability: '',
                    governorate: '',
                    permissionTime: '',
                    accompanyingNationalNumJOR: '',
                    accompanyingFullName: '',
                    accompDocumentType: '',
                    accompDocumentNum: '',
                    relativeRelation: '',
                    mobile: '',
                },
                beneficiaryNaturesList: [],
                governorateList: [], // LookUp
                typeOfDisabilityList: [],
                relativeRelationList: [],
                attachmentTypesList: [], // To save global attachent types
                fileCategory: null, // current uploaded files category
                files: [], // Just For Preview On Init get files & save them in it
                uploadedList: [], // Saved Files In Uploader Weather Success or failed
                filesList: [], // Saved Success Files That Exist In Uploader
                fileCategoriesList: [], // to save files with its categories if all currect save categories and then save files
                treeId: 182,
                jordanianin: true,
                permissionTimes: [{ value: 1, time: 'من الساعة 10-12' }, { value: 2, time: 'من الساعة 3-1' }],
            };
        },
        async created() {
            /* to call the  Entities(drop down lists)  which are used in this Entity */
            await this.getAttachmentTypes();
            await this.getBeneficiaryNatures();
            await this.getGovernorate();
            await this.getTypeOfDisability();
            await this.getRelativeRelation();

            const requestpermissionId = this.$route.params.id;
            if (requestpermissionId) {
                /* add loading in edit mode */
                this.$store.dispatch('showLoading');
                const requestpermission = (await RequestpermissionService.getRequestpermission(requestpermissionId)).data;
                this.$store.dispatch('hideLoading');
                if (!requestpermission) this.$router.push({ name: 'requestpermission' });
                await this.ShowCorrectField(requestpermission.natureBeneficiary);
                this.requestpermission = { ...this.requestpermission, ...requestpermission };
                this.getUploadedFiles();
            }
        },

        methods: {
            /* save Operation */
            async saveRequestpermission() {
                this.attachmentTypesList.forEach(element => {
                    const fileCategoryIndex = this.files.findIndex(item => item.fileCategoryId === element.id);
                    if (element.isMandatory && fileCategoryIndex === -1) {
                        this.$store.dispatch('showMessage', { text: 'حمل المرفقات الاجبارية', color: 'warning' });
                        return;
                    }
                });

                const isValid = await this.$validator.validateAll();
                if (isValid) {
                    const failedFiles = this.filesList.filter(item => item.status === 'error');
                    const inProgressFiles = this.filesList.filter(item => item.status === 'uploading' || item.status === 'queued');
                    if (failedFiles.length > 0) {
                        this.$store.dispatch('showMessage', {
                            text: this.$t('some-files-failed-to-upload'),
                            color: 'error'
                        });
                        return;
                    }
                    if (inProgressFiles.length > 0) {
                        this.$store.dispatch('showMessage', {
                            text: this.$t('some-files-in-progress-upload'),
                            color: 'warning'
                        });
                        return;
                    }
                    if (this.fileCategory && this.fileCategory.isMandatory && this.uploadedList.length === 0) {
                        this.$store.dispatch('showMessage', {
                            text: this.$t('please-upload-attachments-first'),
                            color: 'warning'
                        });
                        return;
                    }

                    /* add loading on save */
                    this.$store.dispatch('showLoading');
                    const result = await RequestpermissionService.saveRequestpermission(this.requestpermission);
                    if (result.data.statusCode === 200) {
                        this.requestpermission.id = parseInt(result.data.id, 10);
                        if (this.fileCategoriesList.length > 0) {
                            this.fileCategoriesList.forEach(item => this.finalSaveFileForm(this.requestpermission.id, item));
                            this.fileCategoriesList.forEach(categoryItem => {
                                categoryItem.uploadedFiles.forEach(item => this.finalSaveFileForm(this.requestpermission.id, categoryItem.id, item.response));
                            });
                        }
                        this.startWorkflow();
                        this.$store.dispatch('showMessage', { text: result.data.message });
                    } else {
                        this.$store.dispatch('showMessage', { text: result.data.message, color: 'error' });
                        this.$router.push({ name: 'requestpermission', color: 'error' });
                    }
                    this.$store.dispatch('hideLoading');
                }
            },
            async getAttachmentTypes() {
                this.attachmentTypesList = (await FileCategoryService.getFileCategoryByCriteria({ keyword: '', pageCodeID: 247 })).data;
            },
            /*File Operation*/
            saveCategoryLocal() {
                if (!this.fileCategory) {
                    this.$store.dispatch('showMessage', {
                        text: this.$t('please-select-attachment-type-first'),
                        color: 'error'
                    });
                    return;
                }
                const failedFiles = this.filesList.filter(item => item.status === 'error');
                const inProgressFiles = this.filesList.filter(item => item.status === 'uploading' || item.status === 'queued');
                if (failedFiles.length > 0) {
                    this.$store.dispatch('showMessage', {
                        text: this.$t('some-files-failed-to-upload'),
                        color: 'error'
                    });
                    return;
                }
                if (inProgressFiles.length > 0) {
                    this.$store.dispatch('showMessage', {
                        text: this.$t('some-files-in-progress-upload'),
                        color: 'warning'
                    });
                    return;
                }
                if (this.fileCategory.isMandatory && this.uploadedList.length === 0) {
                    this.$store.dispatch('showMessage', {
                        text: this.$t('please-upload-attachments-first'),
                        color: 'warning'
                    });
                    return;
                }

                this.fileCategoriesList.push({ ...this.fileCategory, uploadedFiles: this.uploadedList });
                this.uploadedList.forEach(element => {
                    this.files.push({
                        fileCategoryId: this.fileCategory.id,
                        uuid: element.file.upload.uuid,
                        url: element.response.vPath,
                        type: element.response.fileExtension,
                        categoryName: this.fileCategory.fileName
                    });
                });

                this.uploadedList = [];
                this.fileCategory = null;
            },
            async getUploadedFiles() {
                this.files = [];
                const uploadedFilesList = (await PageService.getPages({
                    treeId: this.treeId,
                    instanceId: this.requestpermission.id,
                    keyWord: ''
                })).data;
                uploadedFilesList.forEach(element => {
                    this.files.push({
                        id: element.id,
                        url: element.path,
                        type: element.fileExtension,
                        fileCategoryId: element.fileCategoryId,
                        beneficiaryInformationId: this.requestpermission.id,
                        categoryName: element.arLabel
                    });
                });
            },
            async finalSaveFileForm(instanceId, fileCategory) {
                const saveFileTODB = fileCategory.uploadedFiles;
                saveFileTODB.forEach(element => {
                    const fileIndex = this.files.findIndex(item => item.uuid === element.file.upload.uuid);
                    const pageBody = {
                        arLabel: this.files[fileIndex].categoryName,
                        enLabel: this.files[fileIndex].categoryName,
                        instanceId: instanceId,
                        path: element.response.aPath,
                        id: 0,
                        treeId: this.treeId,
                        tag: '',
                        OriginalId: 0,
                        versionNo: 0,
                        fileExtension: element.response.fileExtension,
                        fileCategoryId: this.files[fileIndex].fileCategoryId //this
                    };
                    const res = (PageService.savePage(pageBody, this.treeId)).data;
                    if (res.statusCode !== 200)
                        this.$store.dispatch('showMessage', {
                            text: res.message,
                            color: 'error'
                        });
                });
            },
            removeFile(fileIndex) {
                // remove if file saved
                if (this.files[fileIndex].beneficiaryInformationId && this.files[fileIndex].id) {
                    this.$store.dispatch('confirm');
                    ConfirmationEvent.$on('onSuccess', async () => {
                        const body = [
                            {
                                treeId: this.treeId,
                                instanceId: this.beneficiaryInformation.saveBeneficiaryInformationManagementDto.id,
                                id: this.files[fileIndex].id
                            }
                        ];
                        const res = (await PageService.deletePages(body)).data;
                        if (res.statusCode === 200) {
                            const categoryIndex = this.beneficiaryInformation.lstSaveFileCategoryDto.findIndex(
                                item => item.id === this.files[fileIndex].id
                            );
                            this.beneficiaryInformation.lstSaveFileCategoryDto.splice(categoryIndex, 1);
                            this.$store.dispatch('showMessage', { text: res.message });
                        } else {
                            this.$store.dispatch('showMessage', {
                                text: res.message,
                                color: 'error'
                            });
                        }
                    });
                }

                // this remove item before save
                if (this.files[fileIndex].fileCategoryId) {
                    const fileCategoryIndex = this.fileCategoriesList.findIndex(item => item.id === this.files[fileIndex].fileCategoryId);
                    const fileIndexInCategory = this.fileCategoriesList[fileCategoryIndex].uploadedFiles.findIndex(
                        item => item.file.upload.uuid === this.files[fileIndex].uuid
                    );

                    this.fileCategoriesList[fileCategoryIndex].uploadedFiles.splice(fileIndexInCategory, 1);
                    this.files.splice(fileIndex, 1);
                }
            },
            /*end file operation*/
            async startWorkflow() {
                this.$store.dispatch('showLoading');
                const result = await RequestpermissionService.startWF({
                    applicationId: this.requestpermission.id,
                    processId: 62
                });
                if (result.data.statusCode === 200) {
                    this.$store.dispatch('showMessage', { text: result.data.message });
                } else
                    this.$store.dispatch('showMessage', {
                        text: result.data.message,
                        color: 'error'
                    });
                this.$store.dispatch('hideLoading');
            },

            async GetCSPDNameBYNationalNum(NationalNum) {
                const result = await BeneficiaryInformationManagementService.GetCSPDNameBYNationalNum(NationalNum);
                this.requestpermission.beneficiaryFullName = result.data;
            },

            async ShowCorrectField(code) {
                if (code === 1) {
                    this.jordanianin = true;
                } else {
                    this.requestpermission.beneficiaryNationalNumJOR = "0000000000";
                    this.jordanianin = false;
                }
            },

            /* Get Operations */
            getBeneficiaryNatures() { /* Static List For BeneficiaryNatures */
                this.beneficiaryNaturesList.push(
                    {
                        code: 1,
                        name: 'jordanian'
                    },
                    {
                        code: 2,
                        name: 'non-jordanian'
                    },
                    {
                        code: 3,
                        name: 'jordanians-sons'
                    },
                    {
                        code: 4,
                        name: 'Gaza-sons'
                    }
                );
            },

            async getGovernorate() { /*Lookup List For Governorate */
                this.governorateList = (await LookUpService.getLookup(62)).data;
            },

            async getTypeOfDisability() { /*Lookup List For TypeOfDisability */
                this.typeOfDisabilityList = (await LookUpService.getLookup(8121)).data;
            },

            async getRelativeRelation() { /*Lookup List For RelativeRelation */
                this.relativeRelationList = (await LookUpService.getLookup(166)).data;
            },

        },
        components: {
            Uploader,
            FilesViewer,
            ActionsBar
        }
    };
</script>
